import { Product } from './../types/product';
import { isNumber } from "lodash";
import { Log, LogBook } from "../types/logBook";
import { Org } from "../types/org";
import { ProductCategory } from "../types/product";
import { User, UserPermission, UserPermissionEnum } from "../types/user";
import { Doc, DocTypeEnum } from '../types/doc';
import { ScanCodeItem, ScanOrder } from '../types/scan';
import { WFile } from "@/types/file";
import { ChangeEnum, ConfirmedEnum, CountingItem, CountingOrder, His, Inventory, OrderItem, Order, OrderEnum, OperateEnum, CountingStateEnum } from "@/types/inventory";
import { App } from '@/types/app';
import { Customer, Price, PriceHis, SaleOrder } from '@/types/sales';
import { SourceTypeEnum } from '@/types/common';

export const isEnum = (
  value: unknown,
  enumType: object
): boolean => {
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return !!Object.entries(enumType).find(entry => entry[1] === value)
  }
  return false;
};

export const isStringEmpty = (value: unknown): boolean => {
  if (value === null || value === undefined) {
    return true;
  }
  if (typeof value === "string" && value.trim() === "") {
    return true;
  }
  return false;
};

export const isString = (value: unknown): boolean => {
  return typeof value === "string";
};

export const isBoolean = (value: unknown): boolean => {
  return typeof value === "boolean";
};

export const isArray = <T>(value: unknown): value is T[] => {
  return Array.isArray(value);
};

export const isUser = (data: unknown) => {
  if (typeof data === "object" && data !== null) {
    const userData = data as User;
    return (
      !isStringEmpty(userData.id) &&
      isString(userData.id) &&
      !isStringEmpty(userData.mobile) &&
      isString(userData.mobile)
    );
  }
  return false;
}

export const isOrg = (data: unknown) => {
  if (typeof data === "object" && data !== null) {
    const orgData = data as Org;
    return (
      !isStringEmpty(orgData.id) &&
      isString(orgData.id) &&
      !isStringEmpty(orgData.rootId) &&
      isString(orgData.rootId) &&
      (!isStringEmpty(orgData.pId) &&
        isString(orgData.pId) || orgData.pId === null) &&
      !isStringEmpty(orgData.logBookId) &&
      isString(orgData.logBookId)
    );
  }
  return false;
}

export const isPermission = (data: unknown) => {
  if (typeof data === "object" && data !== null) {
    const permissionData = data as UserPermission;
    return (
      ((
        !isStringEmpty(permissionData.orgId) &&
        isString(permissionData.orgId)
      ) || permissionData.orgId === null) &&
      !isStringEmpty(permissionData.userId) &&
      isString(permissionData.userId) &&
      isEnum(permissionData.permission, UserPermissionEnum)
    );
  }
  return false;
}

export const isCategory = (data: unknown) => {
  if (typeof data === "object" && data !== null) {
    const categoryData = data as ProductCategory;
    return (
      !isStringEmpty(categoryData.id) &&
      isString(categoryData.id) &&
      (
        !categoryData.pId || (
        !isStringEmpty(categoryData.pId) &&
        isString(categoryData.pId)
      ) || categoryData.pId === null) &&
      !isStringEmpty(categoryData.path) &&
      isString(categoryData.path) &&
      isString(categoryData.code) &&
      isString(categoryData.name)
    );
  }
  return false;
}

export const isProduct = (data: unknown) => {
  if (typeof data === "object" && data !== null) {
    const productData = data as Product;
    return (
      (!productData.categoryId || (
        !isStringEmpty(productData.categoryId) &&
        isString(productData.categoryId)
      ) || productData.categoryId === null) &&
      !isStringEmpty(productData.id) &&
      isString(productData.id) &&
      isString(productData.code) &&
      isString(productData.name) &&
      isString(productData.model) &&
      isString(productData.uom)
    );
  }


  return false;
}

export const isLogBook = (data: unknown) => {
  if (typeof data === "object" && data !== null) {
    const logBookData = data as LogBook;
    return (
      !isStringEmpty(logBookData.id) &&
      isString(logBookData.id) &&
      isString(logBookData.name) &&
      ((isNumber(logBookData.count) && logBookData.count >= 0) ||
        logBookData.count === null)
    );
  }
  return false;
}

export const isLog = (data: unknown) => {
  if (typeof data === "object" && data !== null) {
    const logData = data as Log;
    return (
      !isStringEmpty(logData.id) &&
      isString(logData.id) &&
      (isString(logData.content) || logData.content === null) &&
      ((isNumber(logData.docId) || logData.docId === null))
    );
  }
  return false;
}

export const isDoc = (data: unknown) => {
  if (typeof data === "object" && data !== null) {
    const docData = data as Doc;
    return (
      !isStringEmpty(docData.id) &&
      isString(docData.id) &&
      !isStringEmpty(docData.rootId) &&
      isString(docData.rootId) &&
      !isStringEmpty(docData.name) &&
      isString(docData.name) &&
      isEnum(docData.nodeType, DocTypeEnum)
    );
  }
  return false;
}

export const isScan = (data: unknown) => {
  if (typeof data === "object" && data !== null) {
    const scanData = data as ScanOrder;
    return (
      !isStringEmpty(scanData.id) &&
      isString(scanData.id) &&
      isString(scanData.docId) &&
      isArray<ScanCodeItem>(scanData.items)
    )
  }
  return false;
}

export const isFile = (data: unknown) => {
  if (typeof data === "object" && data !== null) {
    const filePreUpload = data as WFile;
    return (
      !isStringEmpty(filePreUpload.id) &&
      isString(filePreUpload.id)
    )
  }
  return false;
}

export const isInventory = (data: unknown) => {
  if (typeof data === "object" && data !== null) {
    const inventoryData = data as Inventory;
    return (
      !isStringEmpty(inventoryData.id) &&
      isString(inventoryData.id) &&
      isNumber(inventoryData.quantity) &&
      isProduct(inventoryData.product)
    )
  }
  return false;
}

export const isInventoryHis = (data: unknown) => {
  if (typeof data === "object" && data !== null) {
    const inventoryHisData = data as His;
    return (
      !isStringEmpty(inventoryHisData.id) &&
      isString(inventoryHisData.id) &&
      !isStringEmpty(inventoryHisData.inventoryId) &&
      isString(inventoryHisData.inventoryId) &&
      !isStringEmpty(inventoryHisData.inventoryOrderId) &&
      isString(inventoryHisData.inventoryOrderId) &&
      !isStringEmpty(inventoryHisData.inventoryOrderItemId) &&
      isString(inventoryHisData.inventoryOrderItemId) &&
      isEnum(inventoryHisData.changeType, ChangeEnum) &&
      isString(inventoryHisData.changeSource) &&
      isNumber(inventoryHisData.quantity) &&
      isNumber(inventoryHisData.reQuantity)
    )
  }
  return false;
}

export const isOrder = (data: unknown) => {
  if (typeof data === "object" && data !== null) {
    const orderData = data as Order;
    return (
      !isStringEmpty(orderData.id) &&
      isString(orderData.id) &&
      !isStringEmpty(orderData.orgId) &&
      isString(orderData.orgId) &&
      !isStringEmpty(orderData.number) &&
      isString(orderData.number) &&
      isEnum(orderData.changeType, ChangeEnum) &&
      isEnum(orderData.sourceType, SourceTypeEnum) &&
      isEnum(orderData.opType, OperateEnum) &&
      isEnum(orderData.confirmed, ConfirmedEnum) &&
      isEnum(orderData.orderType, OrderEnum)
    )
  }
  return false;
}

export const isCountingOrder = (data: unknown) => {
  if (typeof data === "object" && data !== null) {
    const countingOrderData = data as CountingOrder;
    return (
      !isStringEmpty(countingOrderData.id) &&
      isString(countingOrderData.id) &&
      isEnum(countingOrderData.orderState, CountingStateEnum) &&
      !isStringEmpty(countingOrderData.number) &&
      isString(countingOrderData.number) &&
      (isArray<OrderItem>(countingOrderData.items) || countingOrderData.items === null) &&
      (isArray<ScanOrder>(countingOrderData.scans) || countingOrderData.scans === null)
    )
  }
  return false;
}

export const isCountingItem = (data: unknown) => {
  if (typeof data === "object" && data !== null) {
    const countingItemData = data as CountingItem;
    return (
      !isStringEmpty(countingItemData.id) &&
      isString(countingItemData.id) &&
      !isStringEmpty(countingItemData.orderId) &&
      isString(countingItemData.orderId) &&
      !isStringEmpty(countingItemData.productId) &&
      isString(countingItemData.productId) &&
      !isStringEmpty(countingItemData.counting) &&
      isString(countingItemData.counting) &&
      !isStringEmpty(countingItemData.stock) &&
      isString(countingItemData.stock) &&
      isArray<string>(countingItemData.countingBarcodes) &&
      isArray<string>(countingItemData.stockBarcodes) &&
      isArray<Product>(countingItemData.product)
    )
  }
  return false;
}

export const isSame = <T>(oldV: T, newV: T, keys?: Array<keyof T>) => {
  const basicTypes = ['string', 'boolean', 'number', 'undefined'];
  const oldT = typeof oldV;
  const newT = typeof newV;
  if (oldT !== newT) return false
  if (basicTypes.includes(oldT)) return oldV === newV
  if (oldT === 'object') return !!!(keys?.some(key => oldV[key] !== newV[key]))
  return true
}

export const isApp = (data: unknown) => {
  if (typeof data === "object" && data !== null) {
    const appData = data as App;
    return (
      !isStringEmpty(appData.id) &&
      isString(appData.id) &&
      isNumber(appData.sequence) &&
      !isStringEmpty(appData.fileId) &&
      isString(appData.fileId) &&
      !isStringEmpty(appData.desc) &&
      isString(appData.desc)
    );
  }
  return false;
}

export const isCustomer = (data: unknown) => {
  if (typeof data === "object" && data !== null) {
    const customerData = data as Customer;
    return (
      !isStringEmpty(customerData.id) &&
      isString(customerData.id)
    );
  }
  return false;
}


export const isPrice = (data: unknown) => {
  if (typeof data === "object" && data !== null) {
    const priceData = data as Price;
    return (
      !isStringEmpty(priceData.id) &&
      isString(priceData.id) &&
      !isStringEmpty(priceData.price) &&
      isString(priceData.price)
    );
  }
  return false;
}

export const isPriceHis = (data: unknown) => {
  if (typeof data === "object" && data !== null) {
    const priceHisData = data as PriceHis;
    return (
      !isStringEmpty(priceHisData.id) &&
      isString(priceHisData.id) &&
      !isStringEmpty(priceHisData.price) &&
      isString(priceHisData.price) &&
      !isStringEmpty(priceHisData.priceId) &&
      isString(priceHisData.priceId)
    );
  }
  return false;
}

export const isSaleOrder = (data: unknown) => {
  if (typeof data === "object" && data !== null) {
    const info = data as SaleOrder;
    return (
      !isStringEmpty(info.id) &&
      isString(info.id)
    );
  }
  return false;
}